import React from "react"
import Link from "gatsby-link"
import styles from "../styles/layout.module.css"
import { Helmet } from "react-helmet"
import config from "../../data/config.js"

export default function Layout({ children }) {
return (
  <div className={styles.headerNav}>
          <Helmet>
        <link rel="stylesheet" href="/css/font-awesome.min.css"></link>
</Helmet>
    <Link to={`/`}>
      <h3 className={styles.headerTitle}>
        {config.title}
      </h3>
    </Link>

    <Link className={styles.headerLink} to={`/about/`}>
      About
    </Link>
    <Link className={styles.headerLink} to={`/categories/fm18`}>
      FM18
    </Link>
    <Link className={styles.headerLink} to={`/categories/fm19`}>
      FM19
    </Link>
    <Link className={styles.headerLink} to={`/categories/fm20`}>
      FM20
    </Link>
    {children}
    <div className={styles.footerContainer}>
        <span className={styles.footerContent}>developed with love by nestor</span>
    </div>
    <div className={styles.footerContentGrey}> <a href="https://www.reactjs.org/">React</a>, <a href="https://www.gatsbyjs.org">GatsbyJS</a>, <a href="https://github.com">Github</a> and <a href="https://www.netlify.com">Netifly </a> are used to provide this site
    </div>
  </div>
)
}
